import { callApiWithoutToken } from './api';

import { ApiResult } from '@/types/api';
import { StaffTransportReservation } from '@/types/pickupDropoff';

export const getStaffTransportReservations = async (
  line_id: string,
  lineAccessToken: string,
  office_id: string
): Promise<ApiResult<StaffTransportReservation[]>> => {
  const { status, result } = await callApiWithoutToken<StaffTransportReservation[]>(
    `line/${line_id}/staff/offices/${office_id}/transport-reservations`,
    'GET',
    lineAccessToken
  );
  return { status, result };
};
